import api from "@app/api";
import type { 
    CompanyProcess, 
    CreateCompanyProcessPayload,
    UpdateCompanyProcessPayload,
    UpdateCompanyProcessStatusPayload  
} from "@companyProcess/types/companyProcess";
import { Logs } from "@companyProcess/ui/components/companyProcessLogs/types";

const injected = api.injectEndpoints({
    endpoints: (build) => ({
        getCompanyProcess: build.query<CompanyProcess[], void>({
            query: () => ({url: '/empresa-proceso'})
        }),
        findCompanyProcess: build.query<CompanyProcess, string>({
            query: (id) => ({url: `/empresa-proceso/${id}`})
        }),
        getCompanyProcessByCompany: build.query<CompanyProcess[], string>({
            query: (id) => ({url: `/empresa-proceso/empresa/${id}`})
        }),
        createCompanyProcess: build.mutation<CompanyProcess,CreateCompanyProcessPayload>({
            query: (data) => ({url: '/empresa-proceso', method:'POST', data})
        }),
        updateCompanyProcess: build.mutation<boolean,UpdateCompanyProcessPayload>({
            query: ({id, ...data}) => ({url: `/empresa-proceso/${id}`, method:'PUT', data})
        }),
        deleteCompanyProcess: build.mutation<boolean, number>({
            query: (id) => ({url: `/empresa-proceso/${id}`, method:'DELETE'})
        }),
        updateCompanyProcessStatus: build.mutation<boolean,  UpdateCompanyProcessStatusPayload>({
            query: ({id, detenido, activo}) => ({url: `/empresa-proceso/${id}/status`, method: 'PUT', params:{detenido, activo}})
        }),
        findLogs: build.query<Logs[], string>({
            query: (publicId) => ({ url: `/logs/${publicId}`})
        }),
    })
})

injected.enhanceEndpoints({
    endpoints: {
        getCompanyProcess:{
            providesTags: (result) =>
            result ? [...result.map(({ id }) => ({ type: 'COMPANIES-PROCESS' as const, id })), 'COMPANIES-PROCESS'] : [],
            keepUnusedDataFor: 5,
        },
        findCompanyProcess: {
            providesTags: (result) => result ? [{id: result.id, type: 'COMPANIES-PROCESS'}] : []
        },
        getCompanyProcessByCompany: {
            providesTags: (result) =>
            result ? [...result.map(({ id }) => ({ type: 'COMPANIES-PROCESS' as const, id })), 'COMPANIES-PROCESS'] : [],
            keepUnusedDataFor: 5,
        },
        createCompanyProcess: {
            invalidatesTags: (result) =>
            result ? [{ type: 'COMPANIES-PROCESS', id: result.id }, 'COMPANIES-PROCESS'] : [],
        },
        updateCompanyProcess: {
            invalidatesTags: (_result, error, arg) =>
            !error ? [{ type: 'COMPANIES-PROCESS', id: arg.id }, 'COMPANIES-PROCESS'] : [],
        },
        deleteCompanyProcess: {
            invalidatesTags: (_result, error, arg) =>
            !error ? [{ type: 'COMPANIES-PROCESS', id: arg }, 'COMPANIES-PROCESS'] : [],
        },
        updateCompanyProcessStatus: {
            invalidatesTags: (_result, error, arg) =>
            !error ? [{ type: 'COMPANIES-PROCESS', id: arg.id }, 'COMPANIES-PROCESS'] : [],
        },
    }
})

export const {
    useGetCompanyProcessQuery,
    useFindLogsQuery,
    useFindCompanyProcessQuery,
    useGetCompanyProcessByCompanyQuery, 
    useCreateCompanyProcessMutation, 
    useUpdateCompanyProcessMutation, 
    useDeleteCompanyProcessMutation,
    useUpdateCompanyProcessStatusMutation
} = injected